import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { btnPrimary, FieldError, inputCls } from "@/components/admin/AdminLayout";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(err.response?.status === 401 ? "Incorrect email or password" : errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dot-grid flex min-h-screen items-center justify-center bg-[#121214] px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-lg border border-zinc-800 bg-[#1A1A1E] p-6 shadow-2xl" data-testid="login-form">
        <p className="eyebrow">Owner area</p>
        <h1 className="font-display mt-1 text-4xl text-[#FAF7F2]">Log in</h1>
        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-1.5`} data-testid="login-email-input" required />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} mt-1.5`} data-testid="login-password-input" required />
          </div>
          <FieldError msg={error} testId="login-error" />
          <Button type="submit" disabled={busy} className={`${btnPrimary} w-full`} data-testid="login-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Log in
          </Button>
        </div>
      </form>
    </div>
  );
}
